<template>
  <div v-if="visible" class="modal-backdrop">
    <div class="modal-dialog modal-xxl-custom">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Pacientes na Fila</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>
        <div class="modal-body">
          <ul class="nav nav-tabs mb-3">
            <li class="nav-item">
              <a class="nav-link fw-bold" :class="{active: activeTab === 'aguardando'}" href="#" @click.prevent="activeTab = 'aguardando'">Aguardando</a>
            </li>
            <li class="nav-item">
              <a class="nav-link fw-bold" :class="{active: activeTab === 'chamados'}" href="#" @click.prevent="activeTab = 'chamados'">Últimas chamadas</a>
            </li>
          </ul>
          <div class="table-responsive" style="overflow-y: auto; max-height: 500px;">
            <table class="table table-bordered table-hover">
              <thead>
              <tr>
                <th class="fw-bold">Nome</th>
                <th class="fw-bold">Fila</th>
                <th v-if="activeTab !== 'aguardando'" class="fw-bold text-center">Chamado</th>
                <th v-if="activeTab !== 'aguardando'" class="fw-bold text-center">Confirmado</th>
                <th v-if="activeTab !== 'aguardando'" class="fw-bold text-center">Guichê</th>
                <th class="fw-bold text-center">Ação</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="patient in filteredPatients" :key="patient.id">
                <td>
                  <strong class="fs-5">
                    {{ patient.name }} <br>
                  </strong>
                  <span v-if="patient.sched_date" class="badge bg-primary opacity-50">
                    {{ patient.sched_date ? formatDate(patient.sched_date) + ' - ' : '' }} {{ patient.sched_time }}
                  </span>
                </td>
                <td>
                  <strong class="fs-5">
                    {{ patient.service_queue_name }} <br>
                  </strong>
                  <span v-if="patient.sched_date" class="badge bg-primary opacity-50">
                    {{patient.prof_name}}
                  </span>
                </td>
                <td v-if="activeTab !== 'aguardando'" class="text-center">
                  <span class="fs-5">{{ formatTime(patient.called_at) }}</span>
                </td>
                <td v-if="activeTab !== 'aguardando'" class="text-center">
                  <span class="fs-5">{{ formatTime(patient.released_at) }}</span>
                </td>
                <td v-if="activeTab !== 'aguardando'" class="text-center">
                  <span class="fs-5">{{patient.terminal_caller_name}}</span>
                </td>
                <td class="text-center">
                  <button
                      :class="`btn btn-sm ${!patient.called_at ? 'btn-primary' : 'btn-secondary'} ms-2`"
                      @click="callPatient(patient.id_queue_arrival)"
                  >{{!patient.called_at ? "Chamar" : "Rechamar"}}</button>
                  <!-- <button
                      v-if="activeTab === 'aguardando' && patient.called_at"
                      class="btn btn-sm btn-success ms-2"
                      @click="releasePatient(patient.id_queue_arrival)"
                  >Liberar</button> -->
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import http from "@/helpers/http.js";
import alert from "@/helpers/alert.js";
import moment from 'moment';

export default {
  props: ['visible', 'patients'],
  data() {
    return {
      activeTab: 'aguardando'
    }
  },
  computed: {
    filteredPatients() {
      if (this.activeTab === 'aguardando') {
        return this.patients.filter(p => !p.called_at);
      }
      return this.patients.filter(p => p.called_at);
    },
    place() {
      return this.$store.state.auth.place;
    },
    terminal() {
      return this.$store.state.auth.terminal;
    }
  },
  methods: {
    callPatient(id) {
      http.patch(`/places/${this.place.id_place}/queue-arrivals/${this.terminal.id_terminal}/call/${id}`).then(response => {
        const patient = this.patients.find(p => p.id_queue_arrival === id);
        if (patient) {
          patient.called_at = response.data.called_at;
        }
        alert.toastSuccess('Paciente chamado com sucesso!');
      }).catch(error => {
        alert.toastError('Erro ao chamar paciente!');
        console.error('Erro ao chamar paciente:', error);
      });
    },
    /*releasePatient(id) {
      http.patch(`/places/${this.place.id_place}/queue-arrivals/${this.terminal.id_terminal}/release/${id}`).then(response => {
        const patient = this.patients.find(p => p.id_queue_arrival === id);
        if (patient) {
          patient.released_at = response.data.released_at;
        }
        alert.toastSuccess('Paciente liberado com sucesso!');
      }).catch(error => {
        alert.toastError('Erro ao liberar paciente!');
        console.error('Erro ao liberar paciente:', error);
      });
    }, */
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    },
    formatTime(date) {
      return date ? moment(date).format('HH:mm') : '';
    }
  }
}
</script>

<style>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(2px);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-xxl-custom {
  max-width: 70vw;
  width: 70vw;
}
</style>